var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7145 13.5778L1.06799 2.27773C1.06839 2.27539 1.06919 2.27343 1.06959 2.27109C1.39609 1.04414 2.51679 0.140625 3.84689 0.140625C4.37859 0.140625 4.87779 0.284375 5.30589 0.536725L5.33989 0.556644L17.3239 7.47186L11.7145 13.5778",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4856 15.5016L22.4754 15.5086L17.3016 18.5079L11.4727 13.3211L17.3219 7.47266L22.4684 10.4422C23.3707 10.9293 23.9832 11.8805 23.9832 12.9774C23.9832 14.0664 23.3789 15.0129 22.4856 15.5016",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.06761 23.7243C1.00361 23.4883 0.969971 23.2411 0.969971 22.9844V3.01676C0.969971 2.76054 1.00321 2.5125 1.06801 2.27734L12.0809 13.2883L1.06761 23.7243Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.793 13.002L17.3036 18.511L5.33323 25.4512C4.89813 25.7118 4.39033 25.8622 3.84693 25.8622C2.51683 25.8622 1.39463 24.9571 1.06803 23.7286C1.06763 23.7274 1.06763 23.7266 1.06763 23.7255L11.793 13.002Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/PlayStore.a0a7ae7342e335af2f3e9e1a572c0c91.svg";
export { ForwardRef as ReactComponent };